import React from "react";
import { useTranslation } from "react-i18next";
import U2000ActionBtn from "../../../../u2000Core/components/buttons/U2000ActionBtn";
import U2000ResponsiveToolbar from "../../../../u2000Core/components/toolbar/U2000ResponsiveToolbar";
import { FaPlus, FaRegFile, FaTrashAlt } from "react-icons/fa";
import { useU2000AuthContext } from "../../../../u2000Core/context/auth/U2000UseAuthContext";
import type { U2000FormStateHandlers } from "../../../../u2000Core/reducer/formReducer/U2000FormStateHandlers";
import { U2000FormStateEnumState } from "../../../../u2000Core/reducer/formReducer/U2000FormState";
import { NS, U3107ROLES } from "../../../U3107";

interface U3107EquipmentFormToolBarProps {
  formStateHandlers: U2000FormStateHandlers<Record<string, unknown>> & {
    getData: () => unknown;
    getFormState: () => U2000FormStateEnumState;
    addNewEquipment: () => void;
    modifyEquipment: () => void;
    deleteEquipment: () => void;
  };
}

export const U3107EquipmentFormToolBar: React.FC<U3107EquipmentFormToolBarProps> = ({ formStateHandlers }) => {
  const formState = formStateHandlers.getFormState();
  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();

  const actions = [
    {
      key: "add",
      label: t("btnAdd", { ns: NS }),
      hasRole: hasRole(U3107ROLES.ADD),
      handleClick: () => {
        formStateHandlers.addNewEquipment();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: "modify",
      label: t("btnModify", { ns: NS }),
      hasRole: hasRole(U3107ROLES.EDIT),
      handleClick: () => {
        formStateHandlers.modifyEquipment();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: "delete",
      label: t("btnDelete", { ns: NS }),
      hasRole: hasRole(U3107ROLES.DELETE),
      handleClick: () => {
        formStateHandlers.deleteEquipment();
      },
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
